import type { Dayjs } from 'dayjs'
import { Order } from 'effect'
import type { Ordering } from 'effect/Ordering'
import { z } from 'zod'

const operatorSchema = z.enum(['=', '!=', '<', '>', '<=', '>='])
type Operator = z.infer<typeof operatorSchema>

export function compare(left: Dayjs, right: Dayjs, operator: Operator): boolean {
  switch (operator) {
    case '=': {
      return left.isSame(right)
    }
    case '!=': {
      return !left.isSame(right)
    }
    case '<': {
      return left.isBefore(right)
    }
    case '>': {
      return left.isAfter(right)
    }
    case '<=': {
      return left.isBefore(right) || left.isSame(right)
    }
    case '>=': {
      return left.isAfter(right) || left.isSame(right)
    }
    // eslint-disable-next-line @typescript-eslint/switch-exhaustiveness-check
    default: {
      // eslint-disable-next-line sonarjs/no-dead-store,sonarjs/no-unused-vars
      const x: never = operator
      throw new Error(`unexepected operator`)
    }
  }
}

export function isBetween(target: Dayjs, start: Dayjs, end: Dayjs): boolean {
  return Order.isBetween(DayjsOrder)(target, { minimum: start, maximum: end })
}

const DayjsOrder = Order.make<Dayjs>((x: Dayjs, y: Dayjs): Ordering => {
  if (x.isBefore(y)) return -1
  if (x.isAfter(y)) return 1
  return 0
})
